import Link from 'next/link'
import React, { ReactNode } from 'react'
import type { UrlObject } from 'url'
import { ReactComponentLike } from 'prop-types'
import { StyledAnchor } from '../Anchor'

interface Props {
	href: UrlObject | string
	AnchorComponent?: ReactComponentLike
	children: ReactNode
}

export const SEOLink = ({ href, children, AnchorComponent = StyledAnchor }: Props) => (
	<Link href={href} passHref prefetch={false} legacyBehavior>
		<AnchorComponent>{children}</AnchorComponent>
	</Link>
)
